module.exports = __webpack_public_path__ + "static/media/pathfinding.e8af5d9b.png";